export default __webpack_public_path__ + "static/media/foreground.93438d9a.png";